<template>
    <div>
        <div v-if="isOpen" id="all-notification-dropdown">
            <div class="dropdown-menu show">
                <div class="dropdown-item dropdown-header text-center">
                    <h4 class="m-0">All Notifications</h4>
                    <button type="button" @click="toggle" aria-label="Close" class="close"><i class="nc-icon nc-simple-remove"></i></button>
                </div>
                <a v-for="(notification, index) in notificationList" :key="index" v-b-tooltip.hover="notification.hasLongText" :title="notification.hasLongText ? notification.title : null" class="dropdown-item" :href="'#' + notification.href" v-bind:class="{ read: !notification.unread }" @click.prevent="readNotification(notification.id, notification.href)">
                  {{notification.title}}
                  <small class="time"><font-awesome-icon :icon="['far', 'clock']"/> {{notification.createdAt}}</small>
                </a>
                <infinite-loading @infinite="infiniteHandler"></infinite-loading>
                <!-- <a v-on:click.stop.prevent="maxRow++" class="dropdown-item show-more-notifications text-center py-1" href="">
                    Load More
                </a> -->
            </div>
        </div>
        <div v-if="isOpen" class="close-fixed" @click="close"></div>
    </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'

export default {
  components: {
    InfiniteLoading
  },
  data () {
    return {
      notificationList: [],
      isOpen: false,
      lastPage: false,
      currentPage: 1,
      maxRow: 5
    }
  },
  mounted () {
    this.getNotificationList()
  },
  methods: {
    open () {
      this.isOpen = true
      this.$emit('change', this.isOpen)
    },
    close () {
      this.isOpen = false
      this.$emit('change', this.isOpen)
    },
    toggle () {
      this.isOpen = !this.isOpen
      this.$emit('change', this.isOpen)
    },
    infiniteHandler ($state) {
      if (!this.lastPage) {
        this.getNotificationList().then(() => {
          $state.loaded()
        }).catch(error => {
          $state.error()
          this.$store.dispatch('notification/error', error)
        })
      } else {
        $state.loaded()
        $state.complete()
      }
    },
    getNotificationList (reload = false) {
      return this.$http.get(window.AppConfig.apiUrl + 'notification?is_read=0&limit=20&page=' + this.currentPage)
        .then(response => {
          if (response === undefined) return false
          response.data.data.forEach((notification) => {
            let url = null
            // if (notification.type === 'ServiceOrder') {
            //   url = '#/orders/' + notification.facilityBooking
            // }
            url = '/penjualan/' + notification.serviceOrder
            this.notificationList.push({
              uuid: notification.uuid,
              title: notification.title,
              createdAt: this.$moment(notification.createdAt).from(this.$moment().format()),
              href: url,
              unread: notification.unread,
              hasLongText: notification.title !== null && notification.title.length > 0 ? notification.title.length > 26 : 0
            })
          })
          if (response.data.page_count <= this.currentPage) {
            this.lastPage = true
          }
          if (!reload) {
            this.currentPage++
          }
        })
        .catch(error => {
          return Promise.reject(error)
        })
    },
    readNotification (notificationUuid, url) {
      this.isOpen = true
      this.$emit('click', notificationUuid)
      this.setRead(notificationUuid)
      this.$router.push(url)
    },
    setRead (notificationUuid) {
      let notificationSelectedKey = null
      this.notificationList.forEach((notification, index) => {
        if (notification.uuid === notificationUuid) {
          notificationSelectedKey = index
        }
      })
      if (notificationSelectedKey !== null) {
        this.notificationList[notificationSelectedKey].unread = false
      }
    }
  }
}
</script>


<style lang="scss">
    .close-fixed {
        position: fixed;
        left: 0px;
        top: 0px;
        bottom: 0px;
        right: 301px;
        z-index: 100000;
    }
    #all-notification-dropdown {
        position: fixed;
        right: 1px;
        top: 61px;
        bottom: 0px;
        z-index: 2;
        max-height: 100%;
        background-color: #fff;
        border: 1px solid rgba(0, 0, 0, 0.15);
        .dropdown-menu {
            max-width: 300px;
            min-width: 300px;
            position: relative !important;
            top: 0px;
            padding: 0;
            max-height: 100%;
            overflow-y: scroll;
            padding-top: 44px;
            border: 0px;
            border-radius: 0px;
            .dropdown-item {
                white-space: nowrap; 
                overflow: hidden;
                text-overflow: ellipsis;
                border-bottom: 1px solid rgba(0, 0, 0, 0.15);
                &.read {
                  background: #f7f7f8;
                  color: #ababab;
                }
                &:active {
                  background: #f8f9fa !important;
                }
                &:first-child {
                    // &:hover {
                    //     border-top-left-radius: 0.25rem;
                    //     border-top-right-radius: 0.25rem;
                    // }
                }
                &:last-child {
                    // border-bottom: 0px;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
                    // &:hover {
                    //     border-bottom-left-radius: 0.25rem;
                    //     border-bottom-right-radius: 0.25rem;
                    // }
                }
                &.dropdown-header {
                    position: fixed;
                    right: 1px;
                    top: 61px;
                    width: 301px;
                    height: 47px;
                    background: #fff;
                    color: #212529;
                    cursor: default;
                    &:hover {
                      background: #fff !important;
                    }
                    .close {
                        right: 13px;
                        position: absolute;
                        top: 11px;
                        /* background-color: #000; */
                        display: block;
                        border-radius: 50%;
                        opacity: 1;
                        line-height: 9px;
                        width: 25px;
                        height: 25px;
                        outline: 0!important;
                        font-weight: bold;
                        float: right;
                        font-size: 1.2rem;
                        color: #000;
                    }
                }
                &.show-more-notifications  {
                    background: #fafafa;
                    position: fixed;
                    bottom: 0px;
                    right: 1px;
                    border-top: 1px solid rgba(0, 0, 0, 0.15);
                    width: 301px;
                    &:hover {
                        text-decoration: underline;
                    }
                }
                p {
                    margin: 0px;
                    width: 100%;
                    display: block;
                    font-size: 0.8rem;
                }
                small {
                    width: 100%;
                    display: block;
                    color: #ababab;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Layout/Notifications/Side.vue